"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.14347 1H1.00061V4.14286H4.14347V1ZM1.00061 0C0.448326 0 0.000610352 0.447716 0.000610352 1V4.14286C0.000610352 4.69514 0.448326 5.14286 1.00061 5.14286H4.14347C4.69575 5.14286 5.14347 4.69514 5.14347 4.14286V1C5.14347 0.447715 4.69575 0 4.14347 0H1.00061ZM11.0005 1H7.85762V4.14286H11.0005V1ZM7.85762 0C7.30534 0 6.85762 0.447716 6.85762 1V4.14286C6.85762 4.69514 7.30534 5.14286 7.85762 5.14286H11.0005C11.5528 5.14286 12.0005 4.69514 12.0005 4.14286V1C12.0005 0.447715 11.5528 0 11.0005 0H7.85762ZM11.125 9.75H0.875046H0.375C0.167893 9.75 0 9.58211 0 9.375C0 9.16789 0.167893 9 0.375 9H0.875046H11.125H11.625C11.8321 9 12 9.16789 12 9.375C12 9.58211 11.8321 9.75 11.625 9.75H11.125ZM0.875046 7.5H11.125H11.625C11.8321 7.5 12 7.33211 12 7.125C12 6.91789 11.8321 6.75 11.625 6.75H11.125H0.875046H0.375C0.167893 6.75 0 6.91789 0 7.125C0 7.33211 0.167893 7.5 0.375 7.5H0.875046ZM11.125 12H0.875046H0.375C0.167893 12 0 11.8321 0 11.625C0 11.4179 0.167893 11.25 0.375 11.25H0.875046H11.125H11.625C11.8321 11.25 12 11.4179 12 11.625C12 11.8321 11.8321 12 11.625 12H11.125Z"
}));

exports["default"] = _default;